/**
 * nucleus-monitoring-service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DataSourceInfo } from './dataSourceInfo';
import { ConnectorInfo } from './connectorInfo';


export interface ServiceHealthSummary { 
    serviceName?: string;
    serviceUrl?: string;
    status?: ServiceHealthSummary.StatusEnum;
    responseTimeMs?: number;
    heapUsedMb?: number;
    heapMaxMb?: number;
    heapPercent?: number;
    nonHeapUsedMb?: number;
    threadCount?: number;
    cpuLoad?: number;
    uptimeSeconds?: number;
    dbStatus?: string;
    dbPoolActive?: number;
    dbPoolIdle?: number;
    dbPoolMax?: number;
    dataSources?: Array<DataSourceInfo>;
    kafkaStatus?: string;
    kafkaBootstrapServers?: string;
    connectors?: Array<ConnectorInfo>;
    diskFreeGb?: number;
    diskTotalGb?: number;
    diskPercent?: number;
    gcPauseCount?: number;
    gcPauseTotalMs?: number;
    httpRequestCount?: number;
    httpErrorCount?: number;
    errorLogCount?: number;
    warnLogCount?: number;
    lastChecked?: string;
    alerts?: Array<string>;
    remoteLogAppenderAttached?: boolean;
    remoteLogActive?: boolean;
    remoteLogPersistent?: boolean;
    remoteLogAllowed?: boolean;
    remoteLogLevels?: Set<string>;
    remoteLogConfiguredVia?: string;
}
export namespace ServiceHealthSummary {
    export const StatusEnum = {
        Up: 'UP',
        Down: 'DOWN',
        Warn: 'WARN',
        Unknown: 'UNKNOWN'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


